<!--  -->
<template>
  <div>
    <header class="header-03 sticky" v-if="$route.path.indexOf('/courview/info')<0&&$route.path.indexOf('/mycourses')<0&&$route.path.indexOf('/courviews')<0&&$route.path.indexOf('/liveview')<0&&$route.path.indexOf('/mylive')<0">
        <div class="container-fluid">
            <div class="row">
                <div class="col-lg-12">
                    <nav class="navbar navbar-expand-lg">
                        <!-- logo Start-->
                        <router-link class="navbar-brand" to="/">
                            <img src="/static/images/ZGY_hx_h_n.png" alt="">
                        </router-link>
                        <!-- logo End-->
                        <!-- Select Cate Box -->
                        <div class="catecories-box">
                            <div class="select-item">
                            <select name="categories" v-model="searchType">
                                <option value="" selected="selected">选择搜索</option>
                                <option value="2">考试</option>
                                <option value="3">课程</option>
                                <option value="4">直播</option>
                            </select>
                            </div>
                        </div>
                        <!-- Select Cate Box -->
                        <!-- Search Box -->
                        <div class="search-box">
                            <input type="search" v-model="searchWords" placeholder="搜索信息">
                            <button type="submit" @click="search()"><i class="ti-search"></i></button>
                        </div>
                        <!-- Search Box -->

                        <!-- Moblie Btn Start -->
                        <button class="navbar-toggler" type="button">
                            <i class="fal fa-bars"></i>
                        </button>
                        <!-- Moblie Btn End -->
                        <!-- Nav Menu Start -->
                        <div class="collapse navbar-collapse">
                            <ul class="navbar-nav">
                                <li class="menu-item-has-children">
                                    <router-link to="/">首页</router-link>
                                </li>
                                
                                <li class="menu-item-has-children">
                                    <a href="javascript:void(0);">课程学习</a>
                                    <ul class="sub-menu">
                                        <li><router-link to="/mycourses">我的课程</router-link></li>
                                        <li><router-link to="/courviews">全部课程</router-link></li>
                                    </ul>
                                </li>
                                <li class="menu-item-has-children">
                                    <router-link to="/papercenter">考试中心</router-link>
                                </li>
                                 <li class="menu-item-has-children">
                                     <router-link to="/liveview">直播中心</router-link>
                                </li>
                                <li class="menu-item-has-children">
                                     <router-link to="/examrecord">考试记录</router-link>
                                </li>
                                 <li class="menu-item-has-children">
                                    <router-link to="/mistakelist">错题本</router-link>
                                </li>
                                
                            </ul>
                        </div>
                        <!-- Nav Menu End -->
                        <!-- User Btn -->
                        <a href="#" class="user-btn"><i class="ti-user"></i></a>
                        <!-- User Btn -->
                        <!-- Join Btn -->
                        <a class="join-btn" :style="`color:#fff;${$route.path=='/personcenter'?'background-color: #dc3545;':''}`" @click="EnterPerson()">{{$route.path=="/personcenter"?'退出登录':user().name?user().name:'登录'}}</a>
                        <!-- Join Btn -->
                    </nav>
                </div>
            </div>
        </div>
    </header>
     <header class="header-01 sticky" v-else>
        <div class="container">
            <div class="row">
                <div class="col-lg-12">
                    <nav class="navbar navbar-expand-lg">
                        <!-- logo Start-->
                        <router-link class="navbar-brand" to="/">
                            <img src="assets/images/logo4.png" alt="">
                            <img class="sticky-logo" src="/static/images/ZGY_hx_h_n.png" alt="">
                        </router-link>
                        <!-- logo End-->
                        <button class="navbar-toggler" type="button">
                            <i class="fal fa-bars"></i>
                        </button>
                        <!-- Moblie Btn End -->
                        <div class="collapse navbar-collapse">
                            <ul class="navbar-nav">
                                 <li class="menu-item-has-children">
                                    <router-link to="/">首页</router-link>
                                </li>
                                
                                <li class="menu-item-has-children">
                                    <a href="javascript:void(0);">课程学习</a>
                                    <ul class="sub-menu">
                                        <li><router-link to="/mycourses">我的课程</router-link></li>
                                        <li><router-link to="/courviews">全部课程</router-link></li>
                                    </ul>
                                </li>
                                <li class="menu-item-has-children">
                                    <router-link to="/papercenter">考试中心</router-link>
                                </li>
                                 <li class="menu-item-has-children">
                                     <router-link to="/liveview">直播中心</router-link>
                                </li>
                                <li class="menu-item-has-children">
                                     <router-link to="/examrecord">考试记录</router-link>
                                </li>
                                 <li class="menu-item-has-children">
                                    <router-link to="/mistakelist">错题本</router-link>
                                </li>
                                
                            </ul>
                        </div>
                        <!-- Nav Menu End -->

                        <!-- User Btn -->
                        <a href="#" class="user-btn"><i class="ti-user"></i></a>
                        <!-- User Btn -->

                        <!-- Join Btn -->
                         <a class="join-btn" :style="`color:#fff;${$route.path=='/personcenter'?'background-color: #dc3545;':''}`" @click="EnterPerson()">{{$route.path=="/personcenter"?'退出登录':user().name?user().name:'登录'}}</a>
                        <!-- Join Btn -->
                    </nav>
                </div>
            </div>
        </div>
    </header>
  </div>
</template>

<script>
import global from "@/components/PublicComs/Common.vue";
export default {
  data() {
    return {global,searchType:"",searchWords:""};
  },
  mounted() {
    // this.global.loadScript('/static/js/theme.js',function(){
    //     console.log('加载完成');
    // });
    this.$nextTick(function() {
        console.log("come here 11")
        $('.select-item select').niceSelect();
    })
  },
  methods: {
    user() {
      return this.$store.getters.user;
    },
    EnterPerson(){
        if(this.$route.path=="/personcenter"){
             localStorage.removeItem("eleTokenCustCysd001");
            this.$store.dispatch("clearCurrentState");
            // 页面跳转
            this.$router.push("/login");
        }
        else{
            this.$router.push("/personcenter");
        }
    },
    search() {
        if(this.searchType==''||this.searchWords=="")
        {
            return;
        }
        if(this.searchType=="2")
        {
            this.$router.push("/exam?searchWords="+searchWords);
        }else if(this.searchType=="3")
        {
            this.$router.push("/courviews?searchWords="+searchWords);
        }else if(this.searchType=="4")
        {
            this.$router.push("/liveview?searchWords="+searchWords);
        }
    }
  },
};
</script>
<style scoped>
</style>
